import React from 'react';

const WhatsAppButton = () => {
  const phoneNumber = '923346802015';
  const message = 'Hello, I have a question about LearnVault.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      className="whatsapp-floating-btn"
      target="_blank"
      rel="noopener noreferrer"
      onContextMenu={e => e.preventDefault()}
      onDragStart={e => e.preventDefault()}
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        backgroundColor: '#25D366',
        color: 'white',
        borderRadius: '50%',
        width: '64px',
        height: '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0px 6px 16px rgba(37, 211, 102, 0.4)',
        zIndex: 2147483647,
        cursor: 'pointer',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        textDecoration: 'none',
        pointerEvents: 'auto', // Overrides global DRM block on <a> tags
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'scale(1.1)';
        e.currentTarget.style.boxShadow =
          '0px 8px 20px rgba(37, 211, 102, 0.6)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow =
          '0px 6px 16px rgba(37, 211, 102, 0.4)';
      }}
      title="Contact us on WhatsApp"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="38"
        height="38"
        fill="currentColor"
        style={{ pointerEvents: 'none' }}
      >
        <path d="M19.056 4.908C17.18 3.033 14.685 2 12.029 2 6.541 2 2.069 6.463 2.067 11.943c-.001 1.748.455 3.454 1.32 4.957L2 22l5.247-1.373c1.455.795 3.09 1.213 4.777 1.213h.003c5.485 0 9.96-4.464 9.963-9.945.002-2.651-1.026-5.143-2.934-7.017v.03zm-7.027 15.01c-1.48 0-2.93-.396-4.197-1.144l-.302-.178-3.118.815.834-3.03-.195-.31c-.838-1.332-1.282-2.868-1.28-4.453.003-4.633 3.784-8.409 8.423-8.409 2.247.001 4.359.873 5.946 2.457 1.587 1.584 2.463 3.69 2.46 5.938-.002 4.634-3.784 8.409-8.419 8.409l-.152-.095zm4.619-6.302c-.253-.127-1.498-.737-1.73-.822-.232-.085-.4-.127-.57.127-.168.254-.654.821-.8 1.011-.147.19-.295.212-.548.085-.253-.127-1.07-.393-2.039-1.253-.755-.67-1.266-1.497-1.413-1.751-.147-.253-.015-.39.111-.516.115-.114.253-.294.38-.442.126-.148.168-.253.253-.423.084-.168.042-.315-.021-.442-.063-.127-.57-1.374-.78-1.881-.205-.494-.413-.427-.57-.435-.147-.007-.315-.007-.484-.007-.168 0-.442.064-.674.316-.232.253-.884.863-.884 2.106 0 1.243.905 2.448 1.031 2.617.127.169 1.785 2.716 4.321 3.751.603.245 1.074.39 1.442.5.607.192 1.161.164 1.597.1.49-.071 1.498-.61 1.708-1.2.212-.591.212-1.096.148-1.201-.064-.105-.233-.169-.485-.295z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
